import React from "react";

function FeeDetails() {
  return <div></div>;
}

export default FeeDetails;
